import { render, staticRenderFns } from "./GraphicStickie.vue?vue&type=template&id=f44d9ef4&scoped=true&"
import script from "./GraphicStickie.vue?vue&type=script&lang=js&"
export * from "./GraphicStickie.vue?vue&type=script&lang=js&"
import style0 from "./GraphicStickie.vue?vue&type=style&index=0&id=f44d9ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d9ef4",
  null
  
)

export default component.exports